import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App';
import { store } from 'app/store';
import AuthProvider from 'AuthProvider';
import NotificationCenter from 'components/NotificationCenter';
import { BrowserRouter } from 'react-router-dom';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <NotificationCenter>
        {/*<AuthProvider>*/}
        <BrowserRouter basename="/">
          <AuthProvider>
            <App />
          </AuthProvider>
        </BrowserRouter>
        {/*</AuthProvider>*/}
      </NotificationCenter>
    </Provider>
  </React.StrictMode>,
);
